import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';

gsap.registerPlugin(ScrollTrigger);

const cta = gsap.timeline({
    scrollTrigger: {
        trigger: '.module--cta',
        pin: false,
        scrub: 0.4,
        start: 'top bottom',
        end: "+=100%",
    },
});

cta
    .from('.cta__image', {
        height: '0%',
    })
    .from('.cta__title__word', {
        x: -200,
        opacity: 0,
        stagger: 0.1,
    }, '<')
    .from('.ctas__item', {
        x: -200,
        stagger: 0.1,
    }, '<')
;
